export type Bilingual = {
  en: string
  fr: string
}

export type ChallengeStat = {
  id: string
  value: Bilingual
  claim: Bilingual
  source: Bilingual
  sourceUrl: string
}

export const challengeIntro = {
  eyebrow: {
    en: 'The challenge',
    fr: 'Le défi',
  },
  headlineLead: {
    en: 'Everything moves faster.',
    fr: 'Tout s’accélère.',
  },
  headlineAccent: {
    en: 'Execution gets harder.',
    fr: 'L’exécution se complexifie.',
  },
  intro: {
    en: 'Powerful technologies, but disconnected. The result: humans are still the glue between systems.',
    fr: 'Des technologies puissantes, mais déconnectées. Résultat : ce sont encore les humains qui font le lien entre les systèmes.',
  },
}

const STATE_OF_AI_URL =
  'https://www.mckinsey.com/mx/our-insights/the-state-of-ai-how-organizations-are-rewiring-to-capture-value'
const AGENTIC_ADVANTAGE_URL =
  'https://www.mckinsey.com/capabilities/quantumblack/our-insights/seizing-the-agentic-ai-advantage'

export const challengeStats: ChallengeStat[] = [
  {
    id: '01',
    value: { en: '78%', fr: '78 %' },
    claim: {
      en: 'of organizations already use AI in at least one function.',
      fr: 'des organisations utilisent déjà l’IA dans au moins une fonction.',
    },
    source: {
      en: 'McKinsey, 2025 — The State of AI',
      fr: 'McKinsey, 2025 — The State of AI',
    },
    sourceUrl: STATE_OF_AI_URL,
  },
  {
    id: '02',
    value: { en: '>80%', fr: '> 80 %' },
    claim: {
      en: 'do not yet see a material contribution to business results from their generative AI initiatives.',
      fr: 'ne constatent pas encore de contribution significative aux résultats de leurs initiatives d’IA générative.',
    },
    source: {
      en: 'McKinsey, 2025 — Seizing the Agentic AI Advantage',
      fr: 'McKinsey, 2025 — Seizing the Agentic AI Advantage',
    },
    sourceUrl: AGENTIC_ADVANTAGE_URL,
  },
  {
    id: '03',
    value: { en: '21%', fr: '21 %' },
    claim: {
      en: 'have fundamentally redesigned at least some workflows around generative AI.',
      fr: 'ont fondamentalement repensé au moins certains processus de travail autour de l’IA générative.',
    },
    source: {
      en: 'McKinsey, 2025 — The State of AI',
      fr: 'McKinsey, 2025 — The State of AI',
    },
    sourceUrl: STATE_OF_AI_URL,
  },
]

export const challengeConclusion = {
  lead: {
    en: 'Fragmented intelligence automates tasks.',
    fr: 'L’intelligence fragmentée automatise des tâches.',
  },
  accent: {
    en: 'Integrated intelligence transforms operations.',
    fr: 'L’intelligence intégrée transforme les opérations.',
  },
  caption: {
    en: 'Technology should adapt to people. Not the other way around.',
    fr: 'La technologie devrait s’adapter aux humains. Pas les humains à la technologie.',
  },
}
